module.exports = __webpack_public_path__ + "img/area-part4-231.b5e35ef0.png";